import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useEcho } from '../providers/EchoProvider';

export function useListChannel(listId: string | undefined) {
  const echo = useEcho();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!echo || !listId) return;

    const channel = echo.private(`list.${listId}`);

    channel
      .listen('.ListUpdated', () => {
        queryClient.invalidateQueries({ queryKey: ['list', listId] });
      })
      .listen('.ListItemCreated', () => {
        queryClient.invalidateQueries({ queryKey: ['listItems', listId] });
      })
      .listen('.ListItemUpdated', () => {
        queryClient.invalidateQueries({ queryKey: ['listItems', listId] });
      })
      .listen('.ListItemDeleted', () => {
        queryClient.invalidateQueries({ queryKey: ['listItems', listId] });
      });

    return () => {
      echo.leave(`list.${listId}`);
    };
  }, [echo, listId, queryClient]);
}
